import { createContext, useContext } from 'react';

export const RadioContext = createContext(null);

export function useArtGamesRadio() {
  const radio = useContext(RadioContext);
  if (!radio) throw new Error('Art Games Radio must be inside its provider');
  return radio;
}
